export default function countPayingProcesses(processes) {
  return processes.reduce(
    (total, process) =>
      process.name === 'pm2-auto-pull' || process.name === 'pm2-logrotate'
        ? total
        : total + 1,
    0,
  )
}
